"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddressType;
(function (AddressType) {
    // The original address the contract was deployed on.
    // Starting with 1.4.1, the contracts are deployed with an EIP155-compatible transaction.
    AddressType["CANONICAL"] = "canonical";
    // An address that was deployed with a transaction compatible with the EIP155 standard.
    // The type is only used for 1.3.0 deployments.
    AddressType["EIP155"] = "eip155";
    // An address that is deployed to the ZkSync VM networks.
    AddressType["ZKSYNC"] = "zksync";
})(AddressType || (AddressType = {}));
